export const FORM_KEY_LINE_ITEMS = 'lineItems'
export const FORM_KEY_RESTOCK = 'restock'
export const FORM_KEY_NOTE = 'note'
export const FORM_KEY_SEND_NOTIFICATION = 'notify'
export const FORM_KEY_SHIPPING_AMOUNT = 'shippingAmount'
export const FORM_KEY_REFUND_AMOUNT = 'refundAmount'
export const FORM_KEY_SUGGESTED_REFUND_CALCULATION_RESULT = 'suggestedRefund'
